var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscipline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16631",
    "data-name": "Group 16631",
    transform: "translate(-2160 -3251)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(2160 3251)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(2160 3264.806) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001---Degree",
    "data-name": "001---Degree",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.881.67a7.34,7.34,0,0,1,.251,1.63,2.419,2.419,0,0,0-2.426.226A9.416,9.416,0,0,0,8.467.667Q9.1.68,9.766.68C10.147.68,10.516.676,10.881.67Zm-.767,5.587a1.743,1.743,0,1,1,1.743-1.743A1.743,1.743,0,0,1,10.114,6.257ZM.006,3.12A9.776,9.776,0,0,1,.355.157,9.776,9.776,0,0,1,.7,3.12,9.776,9.776,0,0,1,.355,6.083,9.776,9.776,0,0,1,.006,3.12ZM1.06,6.142A11.559,11.559,0,0,0,1.4,3.12,11.561,11.561,0,0,0,1.06.1,61.154,61.154,0,0,0,7.739.649,8.972,8.972,0,0,1,8.023,3.12c0,.051,0,.1,0,.147a2.415,2.415,0,0,0-.112,2.284l-.015.037a60.742,60.742,0,0,0-6.833.555ZM8.862,8.7l-.254-.586a.349.349,0,0,0-.457-.181l-.587.259.817-1.96A2.437,2.437,0,0,0,9.612,6.9Zm3.216-.767a.349.349,0,0,0-.457.181l-.258.58L10.616,6.9a2.44,2.44,0,0,0,1.232-.673l.816,1.952Zm7.029-1.69a56.448,56.448,0,0,0-6.762-.627l-.025-.06A2.426,2.426,0,0,0,11.85,2.8,9.7,9.7,0,0,0,11.6.656,58.18,58.18,0,0,0,19.107,0a8.222,8.222,0,0,1,.418,3.12A8.258,8.258,0,0,1,19.107,6.239Z",
    transform: "translate(0)",
    fill: "#3f2566"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscipline);
export default __webpack_public_path__ + "static/media/Discipline.f2a40bb34e97f63dd6595fe54ca3d737.svg";
export { ForwardRef as ReactComponent };